import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import "../../Complaint.css";
import HVTRegistrationForm from "./RegistrationForm/HVTRegistrationForm";
import CommonConfirmationModal from "../../Common/CommonConfirmationModal";
import { useUnsavedChangesGuard } from "./useUnsavedChangesGuard";
import { DEFAULT_VALUES } from "./RegistrationForm/wizardConfig";

const HVTRegistrationModal = ({ onClose }) => {
    const methods = useForm({
        mode: "onChange",
        defaultValues: DEFAULT_VALUES,
    });

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isDirty = methods.formState.isDirty;

    useUnsavedChangesGuard(isDirty && !isSubmitting, onClose);

    const handleCloseClick = () => {
        if (isSubmitting) return;
        if (isDirty) {
            setShowConfirmationModal(true);
        } else {
            onClose();
        }
    };

    return (
        <FormProvider {...methods}>
            <div className="hvt-wizard-modal">
                <div className="modal-header px-3 py-2">
                    <h5 className="modal-title">Home Visit</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={handleCloseClick} disabled={isSubmitting}></button>
                </div>

                <HVTRegistrationForm onClose={onClose} onSubmittingChange={setIsSubmitting} />
            </div>

            {showConfirmationModal && (
                <CommonConfirmationModal
                    setShowConfirmationModal={setShowConfirmationModal}
                    description="You have unsaved registration details. Are you sure you want to close?"
                    onConfirm={() => {
                        setShowConfirmationModal(false);
                        onClose();
                    }}
                />
            )}
        </FormProvider>
    );
};

export default HVTRegistrationModal;
